import { BookingBelonging } from '@spike/belonging-model';

export interface BelongingsRowItem {
    id: number;
    petName: string;
    petBreed: string;
    petPhoto?: string | null;
    hasMedicalAlert: boolean;
    belongings: string;
    date: string;
    roomName: string;
    unitName: string;
    locationName: string;
    notes: string;
}

export const bookingBelongingToItem = (bb: BookingBelonging): BelongingsRowItem => ({
    id: bb.id,
    petName: bb.pet?.name ?? '',
    petBreed: bb.pet?.breedName ?? '',
    petPhoto: null,
    hasMedicalAlert: Boolean(
        bb.pet?.specialConditions?.hasMedicalConditions || bb.pet?.specialConditions?.hasNegativePersonalities
    ),
    belongings: (bb.belongings ?? []).map(item => `${item.itemName} x${item.quantity}`).join(', '),
    date: bb.date ? bb.date.format('MMM D, YYYY') : '',
    roomName: bb.room?.name ?? '',
    unitName: bb.room?.unitName ?? '',
    locationName: bb.marketplaceName ?? '',
    notes: bb.notes ?? ''
});
